import { useMutation } from 'react-query'

import {
  type MarketoFormContext,
  marketoService,
  type MarketoServiceError,
} from '@webapp/core/services/Marketo'

export const useMutateRequestFeatureDemo = () => {
  const mutation = useMutation<void, MarketoServiceError, MarketoFormContext>({
    // The Marketo form id comes from env config inside the service (MARKETO_FORM_ID).
    mutationFn: (context) => marketoService.submitForm(context),
  })

  return {
    mutateAsync: mutation.mutateAsync,
    isLoading: mutation.isLoading,
  }
}
